<div *ngFor="let recommendation of recommendation$|async">
  {{recommendation.recommendationText}}
</div>